$(function() {

    $.fn.right = function() {
        return $(document).width() - (this.offset().left + this.outerWidth());
    }

    function setElHeight(items) {
        items.height(getMaxHeight(items))
    }

    function getMaxHeight(items) {
        return Math.max.apply(null, items.map(function () {
            return $(this).height()
        }).get())
    }

    function closePopup() {
        $.magnificPopup.close()
    }

    // make darkenColor function
    function darkenColor(color) {
        let r = parseInt(color.slice(1,3), 16),
            g = parseInt(color.slice(3,5), 16),
            b = parseInt(color.slice(5,7), 16)

        return '#' + ((1<<24) + (r>>1 <<16) + (g>>1 <<8) + (b>>1)).toString(16).slice(1)
    }

    function debounce(func, wait, immediate) {
        let timeout;

        return function() {
            let context = this, args = arguments;
            let later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function replaceImgToSvg(selector) {
        selector.each( function() {
            let $img      = $(this),
                imgID    = $img.attr('id'),
                imgClass = $img.attr('class'),
                imgURL   = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                let $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if ( typeof imgID !== 'undefined' ) $svg = $svg.attr('id', imgID);

                // Add replaced image's classes to the new SVG
                if ( typeof imgClass !== 'undefined' ) $svg = $svg.attr('class', imgClass+' replaced-svg');

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        });
    }

    function getArrow(path, direction) {
        return `<button type='button' class='${direction}'><img src='${path}' class='to-svg'></button>`
    }

    // function isVisible($el) {
    //     let winTop = $(window).scrollTop();
    //     let winBottom = winTop + $(window).height();
    //     let elTop = $el.offset().top;
    //     let elBottom = elTop + $el.height();
    //     return ((elBottom<= winBottom) && (elTop >= winTop));
    // }

    // function getTranslate3d (el) {
    //     let values = el.css('transform').split(/\w+\(|\);?/)
    //
    //     if ( !values[1] || !values[1].length ) {
    //         return [];
    //     }
    //     return values[1].split(/,\s?/g)
    // }

    replaceImgToSvg($('img.to-svg'))

    const viewport  = $(window).width()
    const container = $('#container')

    const reservationButton = $('.js-reservation-btn')

    if ( reservationButton.length ) {
        reservationButton.css('margin-right', container.right() + 15 + 'px')

        $(window).resize( debounce( function () {
            reservationButton.css('margin-right', container.right() + 15 + 'px')
        }, 100) )
    }

    if ( viewport < 576 ) {
        $('.c-offer-slider').removeAttr('dir')
    }

    const hamburger = $('.js-hamburger')

    if ( hamburger.length ) {
        hamburger.on('click', function () {
            let header = $('.c-header')

            header.toggleClass('active')
            $(this).toggleClass('active')
            $('body').toggleClass('menu-open')
            $('.js-nav').slideToggle().toggleClass('active')

            if ( viewport < 576 ) {
                if ( header.hasClass('active') ) {
                    header.css('background-image', 'url(' + header.attr('data-menu-cover') + ')')
                } else {
                    header.css('background-image', 'unset')
                }
            }
        })
    }

    const navItemsWithSubmenu = $('.js-has-submenu .c-nav__link')
    const navItems = $('.c-nav li:not(.js-has-submenu):not(.js-submenu li)')

    if ( navItemsWithSubmenu.length ) {

      if ( viewport > 1199 ) {
          navItemsWithSubmenu.each( function(key, item) {
              $(item).on('mouseenter', function () {
                  if ( !$(item).hasClass('active') )
                      resetMenus()

                  $(item).addClass('active')

                  let submenu = $(this).siblings('.js-submenu')
                  let offsetX = $(this).offset().left - (container.offset().left + 15) + ($(this).outerWidth() / 2 - 10)

                  if ( !submenu.hasClass('c-dropdown') )
                      submenu.find('.pseudo-arrow').css('left', offsetX + 'px')

                  submenu.fadeIn()

                  submenu.on('mouseleave', function () {
                      $(this).fadeOut()
                      $(this).siblings('.c-nav__link').removeClass('active')
                      $(this).parent().removeClass('active')
                  })
              })
          })

          navItems.each( function(key, item) {
              $(item).on('mouseenter', () => resetMenus())
          })
      } else {
          navItemsWithSubmenu.each( function(key, item) {
              $(item).find('.arrow').on('click', function (e) {
                  e.preventDefault()
                  $(this).parent().toggleClass('active').siblings('.js-submenu').slideToggle()
              })
          })
      }

        function resetMenus() {
            navItemsWithSubmenu.removeClass('active')
            navItemsWithSubmenu.parent().siblings().removeClass('active')
            navItemsWithSubmenu.siblings('.js-submenu').fadeOut()
        }
    }

    const langSwitcher = $('.js-language-switcher')

    if ( langSwitcher.length ) {
        langSwitcher.on('click', function (e) {
            e.preventDefault()
            $(this).toggleClass('active').find('ul').slideToggle()

            const langSwitcherItem = $('.js-language-switcher-item')

            if ( langSwitcherItem.length ) {
                langSwitcherItem.on('click', function (e) {
                    e.preventDefault()
                    var aElement = $(this).find('a')
                    window.location = aElement.attr('href')
                })
            }
        })
    }

    const promoSlider = $('.js-promo-slider')

    let nextArrow = getArrow(viewport > 567 ? '/img/slider_next.svg' : '/img/slider_next_xs.png', 'next')
    let prevArrow =  getArrow(viewport > 567 ? '/img/slider_prev.svg' : '/img/slider_prev_xs.png', 'prev')

    if ( promoSlider.length ) {
        let $slick = promoSlider.on('init', function () {
            const parent = promoSlider.parent()
            replaceImgToSvg(promoSlider.find('img.to-svg'))
            setArrowEvent(parent.find('.left-pseudo'), parent.find('.slick-arrow.prev'))
            setArrowEvent(parent.find('.right-pseudo'), parent.find('.slick-arrow.next'))
        }).slick({
            // fade: true,
            // lazyLoad: 'ondemand',
            autoplay: true,
            slidesToShow: 1,
            dots: true,
            arrows: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            customPaging: function () {
                return '';
            },
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        dots: false,
                    }
                }
            ]
        })

        function setArrowEvent(el, arrow) {
            if ( viewport > 991 ) {
                el.on('mouseenter', function () {
                    arrow.addClass('visible')
                })

                el.on('mouseleave', function () {
                    arrow.removeClass('visible')
                })
            }

            el.on('click', function (e) {
                e.preventDefault()

                if ( $(this).attr('data-direction') === 'next' )
                    $slick.slick('slickNext')
                else
                    $slick.slick('slickPrev')
            })
        }
    }

    const reviewSlider = $('.js-review-slider')

    if ( reviewSlider.length ) {

        let nextArrow = getArrow(viewport > 576 ? '/img/slide_right_alt.svg' : '/img/slide_right_alt_xs.svg', 'next')
        let prevArrow =  getArrow(viewport > 576 ? '/img/slide_left_alt.svg' : '/img/slide_left_alt_xs.svg', 'prev')

        reviewSlider.on('init', function () {
            replaceImgToSvg(reviewSlider.parent().find('img.to-svg'))
        }).slick({
            slidesToShow: 3,
            dots: true,
            arrows: true,
            centerMode: true,
            centerPadding: '0px',
            autoplay: true,
            appendArrows: reviewSlider.closest('.c-reviews').find('.arrows'),
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            customPaging: function () {
                return ''
            },
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        centerPadding: '35px',
                    }
                }
            ]
        })
    }

    makeSliderBlock();
    makeOfferSliderBlock();

    const iconBlock = $('.js-icon-block')
    const iconBlock2 = $('.js-icon-block-2')

    if ( iconBlock.length ) {
        let count = iconBlock.attr('data-count')

        iconBlock.find('.c-icon-block__item').css('width',  `calc(100% / ${count})`)

        if ( viewport < 1199 ) {

            if ( parseInt(count) === 12 || parseInt(count) === 10 ) {
                iconBlock.find('.c-icon-block__item').css('width',  'calc(100% / 4)')
            }
        }

        if ( viewport < 767 ) {

            if ( parseInt(count) === 6 || parseInt(count) === 7 || parseInt(count) === 8 ) {
                iconBlock.find('.c-icon-block__item').css('width',  'calc(100% / 3)')
            }

            if ( parseInt(count) === 5 || parseInt(count) === 4 ) {
                iconBlock.find('.c-icon-block__item').css('width',  'calc(100% / 2)')
            }
        }
    }

    if ( iconBlock.length || iconBlock2.length ) {
        let pageColor = $('body').attr('data-page-color')

        if ( pageColor ) {
            setTimeout(() => {
                iconBlock.find('svg path').css('fill', pageColor)
                iconBlock2.find('svg path').css('fill', pageColor)
            }, 200)
        }
    }

    const listBlock = $('.js-list-block')

    if ( listBlock.length ) {
        let count = listBlock.attr('data-count')

        listBlock.find('ul').css('width',  `calc(100% / ${count})`)

        if ( viewport < 767 ) {

            if ( parseInt(count) === 3 ) {
                listBlock.find('ul').css('width',  '100%')
            }
        }
    }

    const imageSliders = $('.js-image-slider')

    if ( imageSliders.length ) {
        imageSliders.each(function (key, slider) {
            $(slider).magnificPopup({
                delegate: 'a:not(.slick-cloned)',
                type: 'image',
                gallery: {
                    enabled: true
                },
            })

            $(slider).slick({
                lazyLoad: 'progressive',
                slidesToShow: 4,
                variableWidth: true,
                dots: true,
                autoplay: true,
                appendArrows: $(slider).parent().find('.js-arrows'),
                prevArrow: "<button type='button' class='prev'><img src='/img/offer_left.svg' class='to-svg' alt='predchádzajúce'></button>",
                nextArrow: "<button type='button' class='next'><img src='/img/offer_right.svg' class='to-svg' alt='ďalšie'></button>",
                customPaging: function () {
                    return ''
                },
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 3,
                            centerMode: true
                        }
                    },
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '0px',
                            centerMode: true
                        }
                    }
                ]
            })
        })
    }

    // if ( imageSlider.length ) {
    //     imageSlider.magnificPopup({
    //         delegate: 'a:not(.slick-cloned)',
    //         type: 'image',
    //         gallery: {
    //             enabled: true
    //         },
    //     })
    //
    //     imageSlider.slick({
    //         // lazyLoad: 'ondemand',
    //         slidesToShow: 4,
    //         variableWidth: true,
    //         dots: true,
    //         autoplay: true,
    //         appendArrows: imageSlider.parent().find('.js-arrows'),
    //         prevArrow: "<button type='button' class='prev'><img src='/img/offer_left.svg' class='to-svg'></button>",
    //         nextArrow: "<button type='button' class='next'><img src='/img/offer_right.svg' class='to-svg'></button>",
    //         customPaging: function () {
    //             return ''
    //         },
    //         responsive: [
    //             {
    //                 breakpoint: 1199,
    //                 settings: {
    //                     slidesToShow: 3,
    //                     centerMode: true
    //                 }
    //             },
    //             {
    //                 breakpoint: 567,
    //                 settings: {
    //                     slidesToShow: 1,
    //                     centerPadding: '0px',
    //                     centerMode: true
    //                 }
    //             }
    //         ]
    //     })
    // }

    const imageSlider2 = $('.js-image-slider-2')

    if ( imageSlider2.length ) {

        imageSlider2.each(function (key, slider) {
            $(slider).slick({
                // lazyLoad: 'ondemand',
                slidesToShow: 6,
                variableWidth: true,
                dots: true,
                autoplay: true,
                appendArrows: $(slider).parent().find('.js-arrows'),
                prevArrow: "<button type='button' class='prev'><img src='/img/offer_left.svg' class='to-svg' alt='predchádzajúce'></button>",
                nextArrow: "<button type='button' class='next'><img src='/img/offer_right.svg' class='to-svg' alt='ďalšie'></button>",
                customPaging: function () {
                    return ''
                },
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 4,
                            centerMode: true
                        }
                    }
                ]
            })
        })
    }

    const logoSlider = $('.js-logo-slider')

    if ( logoSlider.length ) {
        logoSlider.slick({
            autoplay: true,
            // lazyLoad: 'ondemand',
            slidesToShow: 8,
            arrows: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        })
    }

    const listingToggleContent = $('.c-listing-block-2 .js-toggle-content')

    if ( listingToggleContent.length ) {

        listingToggleContent.on('click', function () {
            let self = $(this)

            self.toggleClass('active')

            if ( self.hasClass('active') ) {
                self.find('.more').hide()
                self.find('.less').show()
            } else {
                self.find('.more').show()
                self.find('.less').hide()
            }

            self.siblings('.toggle__content').slideToggle()
        })
    }

    const pageHeader = $('.js-page-header')

    if ( pageHeader.length ) {
        let buttons = pageHeader.find('.button')

        buttons.on('mouseenter', function () {
            let color = $(this).attr('data-color')
            if ( color ) $(this).css('background-color', darkenColor(color, 8))
        })

        buttons.on('mouseleave', function () {
            let color = $(this).attr('data-color')
            if ( color ) $(this).css('background-color', color)
        })

        // PAGE HEADER MAGNIFIC POPUP
        // pageHeader.find('a[href^="#"]').on('click', function (e) {
        //     e.preventDefault()

        //     $.magnificPopup.open({
        //         items: { src: $($(this).attr('href')) },
        //         type: 'inline',
        //         // alignTop: true,
        //         closeOnBgClick: false,
        //         callbacks: {
        //             open: function () {
        //                 $('.mfp-bg').addClass('contact-popup')
        //                 $('.mfp-content').css('position', 'static')
        //             },
        //             close: function () {
        //                 $('.mfp-bg').removeClass('contact-popup')
        //                 $('.mfp-content').css('position', 'absolute')
        //             }
        //         }
        //     })
        // })
    }

    $('a[href^="#"]').on('click', function(e) {
        // console.log($(this).attr('href'))

        if ( $(this).attr('href') == '#contact-form' ) {
            e.preventDefault()

            $.magnificPopup.open({
                items: { src: '#contact-form' },
                type: 'inline',
                // alignTop: true,
                closeOnBgClick: false,
                callbacks: {
                    open: function () {
                        $('.mfp-bg').addClass('contact-popup')
                        $('.mfp-content').css('position', 'static')
                    },
                    close: function () {
                        $('.mfp-bg').removeClass('contact-popup')
                        $('.mfp-content').css('position', 'absolute')
                    }
                }
            })
        } else if ( $(this).attr('href') == '#offer-form' ) {
            e.preventDefault()

            $.magnificPopup.open({
                items: { src: '#offer-form' },
                type: 'inline',
                // alignTop: true,
                closeOnBgClick: false,
                callbacks: {
                    open: function () {
                        $('.mfp-bg').addClass('offer-popup')
                        $('.mfp-content').css('position', 'static')
                    },
                    close: function () {
                        $('.mfp-bg').removeClass('offer-popup')
                        $('.mfp-content').css('position', 'absolute')
                    }
                }
            })
        }
    })

    const listingBlock6 =  $('.js-listing-block-toggle')

    if ( listingBlock6.length ) {

        const isTextClamped = element => element.scrollHeight > element.clientHeight

        listingBlock6.find('article').each( function (key, item) {
           let contentElement = $(item).find('.content'),
               toggleElement  = $(item).find('.js-toggle')

            if ( isTextClamped(contentElement[0]) ) {
                toggleElement.show()
            }

            toggleElement.on('click', function (e) {
                e.preventDefault()
                $(this).toggleClass('active')
                $(item).toggleClass('active')
            })
        })


        // let contentElement = listingBlock6.find('.content'),
        //     lineHeight = parseFloat(window.getComputedStyle(contentElement, null).getPropertyValue('line-height')),
        //     // lines = contentElement.clientHeight / lineHeight,
        //     moreBtn = categoryBanner.querySelector('.js-more'),
        //     lessBtn = categoryBanner.querySelector('.js-less')
        //
        // const isTextClamped = element => element.scrollHeight > element.clientHeight
        //
        // if ( isTextClamped(contentElement) ) {
        //     moreBtn.style.display = 'block'
        // }
        //
        // moreBtn.addEventListener('click', function (e) {
        //     categoryBanner.classList.add('active')
        //     this.style.display = 'none'
        //     lessBtn.style.display = 'block'
        // })
        //
        // lessBtn.addEventListener('click', function (e) {
        //     categoryBanner.classList.remove('active')
        //     this.style.display = 'none'
        //     moreBtn.style.display = 'block'
        // })
    }

    const popupGallery = $('.js-popup-gallery')

    if ( popupGallery.length ) {
        popupGallery.magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true
            },
        })
    }

    const showGallery = $('.js-show-gallery')

    if ( showGallery.length ) {
        showGallery.on('click', function (e) {
            e.preventDefault()
            $(this).parent().parent().removeClass('active-overlay')
        })
    }

    $('.js-close-modal').on('click', () => closePopup())

    const showPaymentsFooter = $('.js-show-payments')

    if ( showPaymentsFooter.length ) {
        showPaymentsFooter.on('click', function (e) {
            e.preventDefault()
            $(this).parent().siblings('.js-payment').fadeIn()
            $(this).hide()
        })
    }

    const listingBlock5 = $('.js-listing-block-5')

    if ( listingBlock5.length ) {
        setElHeight(listingBlock5.find('.content'))
    }

    // API
    const parameterIconsListing = $('.parameter-icons-listing')

    if ( parameterIconsListing.length ) {

        $.ajax({
            type: 'POST',
            url: parameterIconsListing.attr('data-url'),
            beforeSend: function (response) {},
            complete: function (response) {},
            success: function (response) {
                parameterIconsListing.find('.parameter-icons-listing-results').html(response)
            }
        })
    }

    const apiListing = $('.js-api-listing')

    if ( apiListing.length ) {

        apiListing.each(function (key, item) {
            let $item = $(item);
            doRequest($item.attr('data-url'), {}, 'POST', $item,function (response) {})
        });
    }

    function doRequest(url, data, type, element, callback) {
        $.ajax({
            type: type,
            url: url,
            data: data,
            beforeSend: function (response) {
                $('.js-loader').show()
            },
            complete: function (response) {
                $('.js-loader').hide()
            },
            success: function (response) {
                // console.log(response)
                element.find('.js-api-html').html(response);
                makeSliderBlock();
                makeOfferSliderBlock();
            },
            error: function (response) {
                console.log('error')
            }
        })
    }

    function makeSliderBlock(){

        const slidersBlock1 = $('.js-slider-block-1')

        if ( slidersBlock1.length ) {

            slidersBlock1.each(function (key, slider) {

                $(slider).closest('.c-slider-block-1').find('.params__item').each(function (key, item) {
                    $(item).css({
                        width: $(item).find('p').width() + 48
                    })
                })

                $(slider).magnificPopup({
                    delegate: 'a:not(.slick-cloned)',
                    type: 'image',
                    gallery: {
                        enabled: true
                    },
                })

                $(slider).on('init', function () {
                    replaceImgToSvg($(slider).find('img.to-svg'))
                }).slick({
                    lazyLoad: 'ondemand',
                    dots: true,
                    prevArrow: "<button type='button' class='prev'><img src='/img/slider_block_prev.svg' class='to-svg' alt='predchádzajúce'></button>",
                    nextArrow: "<button type='button' class='next'><img src='/img/slider_block_next.svg' class='to-svg' alt='ďalšie'></button>",
                    customPaging: function () {
                        return ''
                    }
                })
            })
        }
    }

    function makeOfferSliderBlock(){

        const offerSliders = $('.js-offer-slider')

        if ( offerSliders.length ) {

            offerSliders.each(function (key, slider) {
                let color = $(slider).attr('data-color')

                $slick = $(slider).on('init', function () {
                    let self = $(this)

                    if ( viewport > 576 ) {
                        if ( self.hasClass('offset-left') ) {
                            $(slider).find('.slick-list').css('margin-left', container.offset().left + 15)
                        }
                        else if ( self.hasClass('offset-right') ) {
                            $(slider).find('.slick-list').css('margin-right', container.right() + 15)
                        }
                    }

                    // if ( self.hasClass('offset-right') && viewport <= 575 ) {
                    //     console.log($(slider))
                    //     setTimeout( () => {
                    //         $(slider).find('.slick-track').css({
                    //             "transform": "translate3d(0px, 0px, 0px)"
                    //         })
                    //     }, 2000)
                    // }

                    replaceImgToSvg(self.find('img.to-svg'))
                    setTimeout( () => {
                        setColorTheming(self, color)
                    }, 500)
                }).slick({
                    // lazyLoad: 'ondemand',
                    // && viewport > 576
                    rtl: $(slider).hasClass('offset-right'),
                    infinite: true,
                    // slidesToShow: 1,
                    // slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    variableWidth: true,
                    // centerPadding: '0px',
                    // touchThreshold: 20,
                    // centerMode: true,
                    appendArrows: $(slider).parent().find('.js-arrows'),
                    prevArrow: "<button type='button' class='prev'><img src='/img/offer_left.svg' class='to-svg' alt='predchádzajúce'></button>",
                    nextArrow: "<button type='button' class='next'><img src='/img/offer_right.svg' class='to-svg' alt='ďalšie'></button>",
                    customPaging: function () {
                        return ''
                    },
                    responsive: [
                        {
                            breakpoint: 567,
                            settings: {
                                // autoplay: true,
                                arrows: false,
                            }
                        }
                    ]
                })
            })

            function setColorTheming(el, color) {
                if ( viewport > 576 ) {
                    let slickFirst = $(el).find('.slick-slide .first')

                    slickFirst.css('background-color', color)
                    slickFirst.find('.badge').css('background-color', color)

                    $(el).parent().find('.slick-arrow').css('background-color', color)
                    let arrow = slickFirst.find('a svg path')

                    if (arrow.length) {
                        arrow.css('fill', color)
                    } else {
                        setTimeout( () => {
                            arrow = slickFirst.find('a svg path')
                            arrow.css('fill', color)
                        }, 2000)
                    }
                } else {
                    let parent = $(el).parent()
                    let slickHolder = parent.find('.c-offer-slider__item.holder')

                    slickHolder.css('background-color', color)
                    slickHolder.find('.badge').css('background-color', color)

                    let arrow = slickHolder.find('a svg path')
                    if ( arrow.length ) {
                        arrow.css('fill', color)
                    } else {
                        setTimeout( () => {
                            arrow = slickHolder.find('a svg path')
                            arrow.css('fill', color)
                        }, 1000)
                    }
                }
            }
        }
    }

    if ( window.location.hash ) {
        let hash = window.location.hash

        setTimeout( () => {
            if ( $(hash).length ) {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - 100
                }, 500)
            }
        }, 1000)
    }

    $('.js-form-gr').submit(function(event) {
        event.preventDefault();
        let $form = $(this);
        const datakey = $('#js-form-gr-key').attr('data-key');

        grecaptcha.ready(function() {
            console.log('test')
            grecaptcha.execute(datakey, {action: 'send'}).then(function(token) {
                $form.prepend('<input type="hidden" name="token" value="' + token + '">');
                $form.unbind('submit').submit();
            });
        });
    });

    const blogPosts = $('.js-blog-item')

    if ( blogPosts.length ) {
        setElHeight(blogPosts.find('p'))
    }

    // Booking
    const childSelect = $('.js-booking-child')

    if ( childSelect.length ) {
        childSelect.on('change', function() {
            let targetVal = $(this).val()

            let childInputs = $('.c-booking__wrapper .input-wrap:gt(4)')
            let childSelects = $('.c-booking__wrapper .js-booking-child-select')

            childInputs.hide()
            childSelects.each( function(index, item) {
                $(item).prop('disabled', true)
            });

            if ( targetVal > 0 ) {
                childInputs.each( function(index, item) {
                    let key = index + 1

                    if ( key <= targetVal ) {
                        let $item = $(item);
                        $item.show()
                        $item.find('select').prop('disabled', false);
                    }
                })
            }
        })
    }

    const infoModal = $('#info-modal')

    if ( infoModal.length ) {
        // open modal as maginific popup
        $.magnificPopup.open({
            items: { src: infoModal },
            type: 'inline',
            // alignTop: true,
            // closeOnBgClick: false,
            // callbacks: {
            //     open: function () {
            //         $('.mfp-bg').addClass('contact-popup')
            //         $('.mfp-content').css('position', 'static')
            //     }
            // }
        })
    }

    let fired = false

    window.addEventListener('scroll', function () {
        let scroll = window.scrollY
        if ( scroll > 0 && fired === false ) {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=6LdvNwslAAAAALckQm5qLLM8SPFbf28PhFhvfQnt'
            // add attribute data-key
            recaptchaScript.setAttribute('data-key', '6LdvNwslAAAAALckQm5qLLM8SPFbf28PhFhvfQnt')
            recaptchaScript.defer = true
            // add id js-form-gr-key
            recaptchaScript.id = 'js-form-gr-key'
            // console.log(recaptchaScript)
            document.body.appendChild(recaptchaScript)
            fired = true
            // console.log('On scroll fired')
        }
    }, true)

    // Accordion
    const accordion = $('.js-accordion')
    if ( accordion.length ) {
        accordion.find('.c-accordion__title').each(function (key, item) {
            $(item).on('click', function () {
                $(this).toggleClass('active').next().slideToggle()
            })
        })
    }
})
